import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// sesión propia por visitante: cada uno tiene su propia demo
// número de pedido visible: correlativo de 4 dígitos (#0045), nunca el id interno
export const orderNo = (o) => (o && o.seq ? String(o.seq).padStart(4, "0") : "—");

export function getSessionId() {
  // "sumar otro celular a la mesa": el QR compartido trae la sesión para entrar a la MISMA demo
  const shared = new URLSearchParams(window.location.search).get("session");
  if (shared && /^[\w-]{6,64}$/.test(shared)) {
    localStorage.setItem("bodegon_demo_session", shared);
    return shared;
  }
  let id = localStorage.getItem("bodegon_demo_session");
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : `s-${Date.now()}-${Math.random().toString(16).slice(2)}`);
    localStorage.setItem("bodegon_demo_session", id);
  }
  return id;
}

export function getTableFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const t = parseInt(params.get("mesa") || params.get("table") || "7", 10);
  return Number.isFinite(t) && t >= 1 && t <= 12 ? t : 7;
}

export const money = (n) => "$" + Math.round(Number(n) || 0).toLocaleString("es-AR");

// 24 h, sin a. m./p. m.
export const fmtTime = (iso) =>
  new Date(iso).toLocaleTimeString("es-AR", { hour: "2-digit", minute: "2-digit", hour12: false });

export const fmtDateTime = (iso) =>
  new Date(iso).toLocaleDateString("es-AR", { day: "2-digit", month: "2-digit" }) + " " + fmtTime(iso);

export const elapsedMin = (iso) =>
  Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 60000));

const q = (path) => `${path}${path.includes("?") ? "&" : "?"}session=${getSessionId()}`;
export const get = (path) => axios.get(`${API}${q(path)}`).then((r) => r.data);
export const post = (path, body) => axios.post(`${API}${q(path)}`, body).then((r) => r.data);
export const patch = (path, body) => axios.patch(`${API}${q(path)}`, body).then((r) => r.data);

export const METHOD_LABELS = {
  mercadopago: "Mercado Pago",
  modo: "MODO",
  tarjeta: "Tarjeta",
  transferencia: "Transferencia",
  efectivo: "Efectivo",
};

export const STATUS_LABELS = {
  nuevo: "Recibido",
  en_cocina: "En cocina",
  listo: "Listo",
  entregado: "Entregado",
};

export const KITCHEN_CATS = ["entradas", "principales", "pastas", "postres"];

export const TABLE_STATUS = {
  libre: { label: "libre", color: "#FFFFFF", border: "#E5E7EB", text: "#525252" },
  ocupada: { label: "ocupada", color: "#E3F0F9", border: "#A0CDE8", text: "#0A0A0A" },
  pidiendo: { label: "pidiendo", color: "#A0CDE8", border: "#0A0A0A", text: "#0A0A0A" },
  esperando_pago: { label: "esperando pago", color: "#FEF9C3", border: "#EAB308", text: "#0A0A0A" },
  efectivo_pendiente: { label: "efectivo pendiente", color: "#FEE2E2", border: "#DC2626", text: "#DC2626" },
};
